import React, { memo, useCallback } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { uniqueId } from "lodash";
import classes from "./PieChartStyles.module.scss";

export interface PieChartProps {
  data: { name: string; value: number }[];
  color?: string;
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload[0]?.name) {
    return (
      <div className={classes.toolTip}>
        <span className={classes.toolTipContent}>{`${payload[0].name}: ${payload[0].value.toFixed(2)}%`}</span>
      </div>
    );
  }

  return null;
};

const PieChartComponent = memo(({ data, color }: PieChartProps) => {
  const renderCell = useCallback(
    (entry, index) => (
      <Cell key={uniqueId(`pie-${index.toString}`)} fill={entry && entry.name ? entry.color || color : "transparent"} />
    ),
    [color]
  );

  return (
    <ResponsiveContainer width={210} height={210}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          stroke="#111"
          strokeOpacity={0.4}
          strokeWidth={2}
          outerRadius={100}
        >
          {data.map(renderCell)}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </ResponsiveContainer>
  );
});

export default PieChartComponent;
